// @flow
import styled from 'styled-components';
import colors from '../../../assets/css/colors';

export const ErrorField = styled.div`
    color: ${colors.red};
	margin-bottom: .85em;
	font-size: 12px;
	font-weight: bold;
`;

export default ErrorField;


// WEBPACK FOOTER //
// ./src/components/Form/ErrorField/index.js